import type { ButtonHTMLAttributes } from 'react';

import { Icon, type IconName } from '@/components/Icon/Icon';
import { Spinner } from '@/components/Spinner/Spinner';

import styles from './IconButton.module.css';

export interface IconButtonProps extends Omit<
  ButtonHTMLAttributes<HTMLButtonElement>,
  'aria-label' | 'children'
> {
  icon: IconName;
  /** The accessible name, also shown as a tooltip. */
  label: string;
  busy?: boolean;
  tone?: 'neutral' | 'danger';
}

/** A round button carrying only an icon; its name is the tooltip. */
export function IconButton({
  icon,
  label,
  busy = false,
  tone = 'neutral',
  disabled,
  className,
  ...rest
}: IconButtonProps) {
  return (
    <button
      {...rest}
      aria-busy={busy}
      aria-label={label}
      className={[styles.button, styles[tone], className].filter(Boolean).join(' ')}
      disabled={disabled || busy}
      title={label}
      type="button"
    >
      {busy ? <Spinner /> : <Icon name={icon} />}
    </button>
  );
}
